module.exports = __webpack_public_path__ + "media/application/images/home/intro_images/feature_jungle_mob-349dc8bfe8ef04cc7a6a7a6a64042734.jpg";